const topicItems = [
  { title: '顶流塌房全记录', desc: '2026年度网红翻车事件合辑，从爆红到凉凉的完整时间线追踪' },
  { title: '直播圈今日大瓜', desc: '各大直播平台主播间的恩怨情仇与争议事件每日滚动更新' },
  { title: '娱乐圈扒皮专区', desc: '明星艺人的黑历史、绯闻内幕与行业潜规则深度起底' },
  { title: '短视频翻车现场', desc: '抖音快手等平台创作者争议言论、人设崩塌与粉丝脱粉实录' },
  { title: '网红黑料档案馆', desc: '按时间线整理的全网网红负面新闻数据库，支持按人名检索' },
  { title: '塌房预警雷达', desc: 'AI驱动的风险监测系统，提前发现潜在塌房信号与舆论风向变化' },
  { title: '粉丝互撕战场', desc: '饭圈大战、粉丝站互撕、应援争议等粉丝文化热点事件全记录' },
  { title: '海外吃瓜速递', desc: 'YouTube、TikTok等海外平台华人网红的争议事件与跨平台联动追踪' },
];

export default function IndexSection() {
  return (
    <section id="index" className="py-20 md:py-28 bg-background-500">
      <div className="max-w-[1200px] mx-auto px-4 md:px-6">
        <h2 className="text-3xl md:text-4xl font-heading font-black text-foreground-950 mb-14">
          专题索引：热门吃瓜合集
        </h2>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5">
          {topicItems.map((item, idx) => (
            <a
              key={idx}
              href="#"
              className="group bg-background-700 rounded-2xl border border-foreground-900/10 p-6 hover:border-accent-500 transition-all duration-300 hover:-translate-y-1 cursor-pointer"
            >
              <span className="text-5xl font-black text-accent-500/20 font-heading leading-none">
                {(idx + 1).toString().padStart(2, '0')}
              </span>
              <h3 className="mt-3 text-base font-bold text-foreground-950 font-heading group-hover:text-accent-800 transition-colors duration-200">
                {item.title}
              </h3>
              <p className="mt-1.5 text-xs text-foreground-600 leading-relaxed">
                {item.desc}
              </p>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}